import SideBar from "../components/sideBar";
import translateText, { currentLanguage } from "../signals/language.signal";
import OfferImg from "../assets/logo_old.png";
import LazyImage from "../components/LazyImage";
const AboutUs = () => {
  return (
    <div
      id="AboutUs"
      className="align-items-sm-center d-flex  justify-content-center flex-column w-100"
    >
      <SideBar
        more={true}
        showAccount={true}
        title={translateText(currentLanguage.value, "AboutUsTitle")}
      />
      <div className=" loginContaner position-relative mb-1 p-3  w-100  text-center  rounded-3 ">
        <LazyImage src={OfferImg} alt="logo" className="mb-4 mt-4" />
        <p>{translateText(currentLanguage.value, "AboutUs")} </p>
      </div>
    </div>
  );
};

export default AboutUs;
